<template>
  <ankh-list>
    <template #btn-group>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('激活码')">
        <el-input :placeholder="$t('激活码')" v-model="searchForm.activateCode" clearable/>
      </el-form-item>
      <el-form-item :label="$t('激活时间')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="50"/>

        <el-table-column prop="actName" :label="$t('激活码名称')"  fixed/>
        <el-table-column prop="activateCode" :label="$t('激活码')" width="160" fixed />
        <el-table-column prop="startTime" :label="$t('开始时间')">
          <template v-slot="{row}">
            {{row.startTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('结束时间')">
          <template v-slot="{row}">
            {{row.endTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column prop="userNum" :label="$t('激活者会员编号')"/>
        <el-table-column prop="username" :label="$t('激活者昵称')"/>
        <el-table-column prop="username" :label="$t('蓝牙MAC状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="MEMBER_MAC_CODE_STATUS" :status="row.macStatus" />
          </template>
        </el-table-column>
        <el-table-column prop="brandName" :label="$t('品牌名称')"/>
        <el-table-column prop="brandPhoto" :label="$t('品牌图片')">
          <template v-slot="{row}">
            <preview-img :size="40" :img-url="row.brandPhoto" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('会员类型')">
          <template v-slot="{row}">
            <dict-text dict-flag="VIP_TYPE" :status="row.vipType" />
          </template>
        </el-table-column>
        <el-table-column prop="convertNumber" :label="$t('兑换会员期限/月')">
          <template v-slot="{row}">
            {{row.convertNumber}}个月
          </template>
        </el-table-column>
        <el-table-column prop="activeCount" :label="$t('激活次数上限')"/>
        <el-table-column prop="createTime" :label="$t('激活时间')">
          <template v-slot="{row}">
            {{row.startTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="ACTIVE_CODE_STATUS" :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" width="90">
          <template v-slot="{row}">
            <div class="fb-link-flex">
<!--              <el-link :type="row.status === 'open' ? 'danger' : 'primary'" :underline="false" @click="handleChangeStatus(row)">{{ row.status === "open" ? "禁用" : "启用" }}</el-link>-->
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DictText from "@/components/dict/DictText";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "ActiveStatusList",
  components: {AnkhList, PreviewImg, DateTimeRangePicker, DictText, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      addDialog: false,
    }
  },
  methods: {
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "open" ? "close" : "open",
        }
        const message = row.status === "open" ? this.$t('您现在正在进行禁用操作, 是否继续?') : this.$t('您现在正在进行启用操作, 是否继续?')
        await requestByTip(this.$api.activateCodeRecord.updateStatus, params, {}, {message});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.activateCodeRecord.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.activateCodeRecord.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.activateCodeRecord.listStatus, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
